module.exports = __webpack_public_path__ + "img/logo.fde1b388.png";